import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

/* import function from store folder */
import { setAction } from '../../../store/components/searchSlice';
import { resetModel } from '../../../store/components/modelSlice';

/* import element from component folder */
import Select from '../../../components/select';
import Editor from "../../../views/combination/editor";
import Checkbox from "../../../views/combination/columebox";

/* import fetch function */
import { EditDeviceType } from "../../../services/device";

const EditorDevice = () => {
    const { data } = useSelector(state => state.model);
    const dispatch = useDispatch();
    const [error, setError] = useState({});
    const [source, setSource] = useState(data);
    
    const cancelHandler = () => dispatch(resetModel());
    const changHandler = ({target: { name, value }}) => {
        const _source = Object.assign({}, source);
        
        _source[name] = value;

        setError(error);
        setSource(_source);
    };

    const submitHandler = event => {
        event.preventDefault();
        
        EditDeviceType({ dtId: data.dtId, source: source }).then(response => {
            if (!Object.keys(response).length) {
                cancelHandler();
                dispatch(setAction());
            }
        });
    };

    return (
        <Modal show={ true } centered size='lg'>
            <Modal.Header>Edit data</Modal.Header>
            <Modal.Body>
                <Form className="modal-form-container" onSubmit={ submitHandler }>
                    <div className="form-item">
                        <div className='label'>Type</div>
                        <span className='semicolon'>：</span>
                        <Select name='deviceType' select_all={ false } shadow={ false } _default={ data.codeId } disabled />
                    </div>
                    <div className="form-item">
                        <div className='label'>Name</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='name' placeholder='Please enter the device name.' defaultValue={ data.name } disabled />
                    </div>
                    <div className="form-item">
                        <Checkbox defaultValue={ data.columns.split(',') } changeHandle={ changHandler } />
                    </div>
                    <div className="form-item">
                        <Editor source={ source } changeHandle={ changHandler } />
                    </div>
                    <div className="button-container">
                        <Button type="button" data-shadow onClick={ cancelHandler }>Cancel</Button>
                        <Button type="button" data-shadow onClick={ submitHandler }>Submit</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default EditorDevice;